import React from 'react';

const REASONS = [
  {
    body: 'Votes come from verified professionals, not anonymous accounts. Every voter signs in with a The Information login.',
    title: 'Real signal, not internet noise',
  },
  {
    body: 'Real-time reads from The Information community on the companies, deals and products moving tech.',
    title: 'Sentiment you won’t find anywhere else',
  },
  {
    body: 'Five questions, a couple of minutes, straight from today’s headlines. Play it with your morning coffee.',
    title: 'Fast, fun and timely',
  },
];

const WhyPolls = () => (
  <section
    aria-labelledby="polls-why-polls"
    className="bg-[#f7f5f2] py-48 sm:py-64 md:py-80 xl:py-96"
  >
    <div className="mx-auto w-full max-w-[1440px] px-20 sm:px-40 lg:px-64 xl:px-80">
      <p className="m-0 font-suisse-intl-mono text-[14px] uppercase leading-none tracking-widest text-primary-magenta">
        Why polls
      </p>
      <h2
        className="m-0 mt-20 font-suisse-intl text-[30px] font-bold leading-[1.1] tracking-tight text-grayscale-charcoal sm:text-[40px] md:text-[44px] xl:text-[52px] dark:!text-black"
        id="polls-why-polls"
      >
        You have questions.
        <br />
        The Information readers have answers.
      </h2>
      <ul className="m-0 mt-40 grid list-none grid-cols-1 gap-20 p-0 sm:mt-56 md:grid-cols-3 md:gap-24 xl:mt-64 xl:gap-32">
        {REASONS.map(({ body, title }) => (
          <li
            className="rounded-2 border border-solid border-grayscale-beige bg-background-white p-24 xl:p-32"
            key={title}
          >
            <h3 className="m-0 font-suisse-intl text-[20px] font-bold leading-[1.25] text-grayscale-charcoal sm:text-[22px] md:text-[24px]">
              {title}
            </h3>
            <p className="m-0 mt-12 font-suisse-intl text-[16px] font-normal leading-[1.55] text-grayscale-charcoal md:mt-16 xl:text-[18px]">
              {body}
            </p>
          </li>
        ))}
      </ul>
    </div>
  </section>
);

export default WhyPolls;
